window.CartDrawer = Backbone.View.extend({
  Css: {
    Open: 'cart-open',
    NoTrial: 'no-trial',
    FreeTrial: 'free-trial'
  },

  template: _.template(
    '<% _.each(items, function(product) { %>' +
    '  <div class="drawer-item-listing display-flex" data-product-id="<%= product.id %>">' +
    '    <% if(product.price) { %>' +
    '      <a href="<%= product.url %>" aria-label="<%= product.product_title %>" class="drawer-product-image bg-image flex-no-shrink" style="background-image: url(\'<%= product.image %>\')"></a>' +
    '    <% } else { %>' +
    '      <span class="drawer-product-image bg-image flex-no-shrink" style="background-image: url(\'<%= product.image %>\')"></span>' +
    '    <% } %>' +
    '    <div class="drawer-product-details flex-grow padding-left-sm">' +
    '      <p class="drawer-product-name margin-none">' +
    '        <% if(product.price) { %>' +
    '          <a href="<%= product.url %>"><%= product.product_title %></a>' +
    '        <% } else { %>' +
    '          <span><%= product.product_title %></span>' +
    '        <% } %>' +
    '        <span class="product-price margin-none right">' +
    '           <% if(product.properties.TryNow == "true") { %>' +
    '            $0 (<%= product.formatted_price %> if kept)' +
    '           <% } else { %>' +
    '             <% if (!product.isBundle) { %> ' +
    '               <% if (product.compare_at_price) { %> ' +
    '               <strike><%= product.compare_at_price %></strike> ' +
    '               <% } %>' +
    '               <%= product.format_line_price %> ' +
    '             <% } else { %> ' +
    '               <%= product.formatted_price %> ' +
    '             <% } %>' +
    '           <% } %>' +
    '          </span>' +
    '      </p>' +
    '      <p class="product-meta text-capitalize margin-none spacing-xs"><% if (!product.product_has_only_default_variant) { %><%= product.variant_options.join(" / ") %><% } else { %>&nbsp;<% } %></p>' +
    '      <% if((product.product_id.toString() === "4844223791147" || product.price) && product.product_id.toString() != "4468271874091") { %>' +
    '        <% if(!product.isBundle) { %> ' +
    '        <div class="drawer-quantity display-flex">' +
    '          <button type="button" class="drawer-quantity-adjust quantity-minus" data-quantity="-1">' +
    '            <span class="fallback-text" aria-hidden="true">−</span>' +
    '            <span class="sr-only">Reduce item quantity by one</span>' +
    '          </button>' +
    '          <input type="number" disabled class="drawer-quantity-num margin-none" value="<%= product.quantity %>" min="0" aria-label="quantity" pattern="[0-9]*">' +
    '          <% if(product.properties.TryNow != "true") { %>' +
    '           <button type="button" class="drawer-quantity-adjust quantity-plus" data-quantity="1">' +
    '            <span class="fallback-text" aria-hidden="true">+</span>' +
    '            <span class="sr-only">Increase item quantity by one</span>' +
    '          </button>' +
    '           <% } %> ' +
    '        </div>' +
    '        <% } else { %> ' +
    '         <div class="bundle-quantity"><strong><%= product.quantity %></strong> <em>in Bundle</em><button type="button" class="button bundle-remove">Remove</button></div>' +
    '        <% } %> ' +
    '      <% } %>' +
    '    </div>' +
    '  </div>' +
    '<% }); %>'
  ),

  events: {
    'click .cart-close': 'close',
    'click .drawer-quantity-adjust': 'updateProductAmount',
    'click .bundle-remove': 'removeBundle'
  },

  initialize: function() {
    this.isOpen = false;
    this.$body = $(document.body);
    this.$cartItemsNumber = this.$('.cart-items-number');
    this.$cartItemsNumberHeader = $('[data-cart-count]');
    this.$cartItems = this.$('.drawer-items');
    this.$form = $('.product-details-wrapper form');
    this.$discountText = this.$('.drawer-discount');
    this.$totalPrice = this.$('.total-price');
    this.$cartHasItems = this.$('.cart-has-items');
    this.$cartHasNoItems = this.$('.cart-has-no-items');
    this.previousFocus = null;
    this.cartData = null;
    this.$queue = $({});

    $('.navigation-header-cart').on('click', this.open.bind(this));
    $(document).on('keydown', this.onKeyDown.bind(this));
    $('#cart-overlay').on('click', this.overlayClick.bind(this));
    $(document.body).on('afterAddItem.ajaxCart', this.fetchAndOpenCart.bind(this));

    if (location.hash === '#cart') {
      this.fetchAndOpenCart();
    } else {
      this.fetchCart();
    }
  },

  overlayClick: function(event) {
    this.close();
  },

  queueCall: function(ajaxOpts) {
    var oldComplete = ajaxOpts.complete;
    var self = this;

    return this.$queue.queue(function(next) {
      ajaxOpts.complete = function() {
        if (oldComplete) {
          oldComplete.apply(self, arguments);
        }
        next();
      };

      // run the query
      $.ajax(ajaxOpts);
    });
  },

  fetchCart: function() {
    var self = this;

    return this.queueCall({
      url: '/cart.js',
      dataType: 'json',
      success: function(data) {
        self.cartData = data;
        self.isFreeTrial = self.cartData.items.some(function(item) {
          return item.handle.indexOf('try-before-you-buy') > -1;
        });

        if (self.isFreeTrial) {
          self.cartData.total_price = 0;
        }

        if (self.cartData) {
          self.cartData.items = self.cartData.items.map(self.transformProduct.bind(self));
        }
        if (self.cartData.items) {
          self.cartData.items.forEach(function(i) {
            i.format_line_price = self.formatMoney(i.final_line_price);
            if (i.discounts.length > 0) {
              i.compare_at_price = self.formatMoney(i.original_line_price);
            }
            self.queueCall({
              url: i.url,
              dataType: 'json',
              success: function(data) {
                if (data && data.product && data.product.variants) {
                  data.product.variants.some(function(v) {
                    if(v.id === i.variant_id && v.compare_at_price > 0) {
                      i.compare_at_price = self.formatMoney(v.compare_at_price);
                      return true;
                    }
                    return false;
                  });
                }
              }
            });
          });
        }

        self.$queue.queue(function(n) {
          self.render();
          n();
        });
      }
    });
  },

  fetchAndOpenCart: function() {
    this.fetchCart();
    this.$queue.queue(function(next) {
      next();
      this.open();
    }.bind(this));
  },

  transformProduct: function(product) {
    product.formatted_price = this.formatMoney(product.price);
    if (product.image != null){
      product.image = product.image.replace(/(\.[^.]*)$/, '_small$1').replace(/^http(s?):/i, '');
    } else {
      product.image = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
    }

    if (product.properties.bundleId) {
      product.isBundle = true;
    }

    return product;
  },

  formatMoney: function(money) {
    return Shopify.formatMoney(money, Theme.moneyFormat)
  },

  getTryNowSubTotal: function() {
    var tryNowItems = this.cartData.items.filter(item => item.properties.TryNow == 'true');

    if (tryNowItems.length > 0) {
      return tryNowItems.reduce(function(total, item) {
        return total + item.original_line_price;
      }, 0);
    }

    return 0;
  },

  render: function() {
    var tryNowAddToCart = $('#TryNowAddToCart');
    if (!this.cartData) {
      return;
    }

    if (this.isFreeTrial) {
      this.$el.addClass(this.Css.FreeTrial).removeClass(this.Css.NoTrial);
    } else {
      this.$el.removeClass(this.Css.FreeTrial).addClass(this.Css.NoTrial);
    }
    var hasBundle = false;
    if (this.cartData.items.length) {

      this.cartData.items.forEach(function(i) {
        if (i.isBundle) {
          hasBundle = true;
        }
      });

      this.$cartItems.html(this.template(this.cartData));
      var tryNowTotal = this.getTryNowSubTotal();
      if (tryNowTotal > 0) {
        $('#normal_checkout').hide();
        $('#TryNowCheckoutArea').show();
        $('.additional_checkout_buttons').hide();
        var payPrice = this.cartData.total_price - tryNowTotal;
        this.$totalPrice.html(this.formatMoney(payPrice) + '<span class="TryNow__subtotal"> (' + this.formatMoney(this.cartData.total_price) + ' if kept)</span>');
      } else {
        tryNowAddToCart.val('TRY BEFORE YOU BUY - $0').prop('disabled', false);
        $('#TryNowCheckoutArea').hide();
        $('#normal_checkout').show();
        $('.additional_checkout_buttons').show();
        this.$totalPrice.html(this.formatMoney(this.cartData.total_price));
      }

      if (this.cartData.total_discount && !hasBundle) {
        this.$discountText.removeClass('hide').html('You are saving ' + this.formatMoney(this.cartData.total_discount));
      } else {
        this.$discountText.addClass('hide');
      }

      this.$cartHasItems.removeClass('hide');
      this.$cartHasNoItems.addClass('hide');
    } else {
      tryNowAddToCart.val('TRY BEFORE YOU BUY - $0').prop('disabled', false);
      this.$cartItems.html('');
      this.$cartHasItems.addClass('hide');
      this.$cartHasNoItems.removeClass('hide');
    }

    this.setItemCount(this.cartData.item_count);
  },

  setItemCount: function(count) {
    this.$cartItemsNumber.text(count);
    this.$cartItemsNumberHeader.text(count);

    if (count) {
      this.$cartItemsNumber.removeClass('hide');
    } else {
      this.$cartItemsNumber.addClass('hide');
    }
  },

  onKeyDown: function(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  },

  open: function(event) {
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.isOpen) {
      var newPath = window.location.pathname + window.location.search + '#cart';
      history.replaceState({}, document.title, newPath);
      this.isOpen = true;
      this.$body.addClass(this.Css.Open);
      this.previousFocus = document.activeElement;
      this.el.focus();
    }
  },

  close: function(event) {
    if (event && event.originalEvent && !event.originalEvent.isTrusted) {
      return;
    }

    if (this.isOpen) {
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault();
      }

      history.replaceState({}, document.title, window.location.pathname);
      this.isOpen = false;
      this.$body.removeClass(this.Css.Open);
      if (this.previousFocus) {
        this.previousFocus.focus();
      }
    }
  },

  updateProductAmount: function(event) {
    if (!event) {
      return;
    }

    var $target = $(event.currentTarget);
    var amount = $target.data('quantity');
    var index = $target.closest('.drawer-item-listing').data('product-id');
    var item = this.cartData.items.filter(function(item) {
      return item.id === index
    })[0];

    var payload = {
      quantity: item.quantity + amount,
      id: index
    };

    // If we're deleting a mattress with free sheets
    if ((item.product_type === 'Mattress' || item.product_type === 'Topper') && payload.quantity === 0) {
      var containsMattress = this.cartData.items.some(function(item) {
        return item.product_type === 'Mattress' || item.product_type === 'Topper'
      });
      var mattressId = item.id.toString();

      var freeSheets = this.cartData.items.filter(function(cartItem) {
        var isFreeWithMattress = (cartItem.url.indexOf('free-w-mattress') > -1 || cartItem.url.indexOf('free-w-topper') > -1);
        var belongsToMattress = cartItem.properties &&
          cartItem.properties.mattress &&
          cartItem.properties.mattress.indexOf(mattressId) > -1;

        return isFreeWithMattress && (
          !containsMattress || belongsToMattress
        );
      });

      payload = {
        updates: {}
      };

      if (freeSheets.length) {
        freeSheets.forEach(function(freeSheet) {
          payload.updates[freeSheet.id] = 0;
        });
      }

      payload.updates[item.id] = 0;

      this.queueCall({
        method: 'POST',
        url: '/cart/update.js',
        data: payload
      });
    } else {
      if (item.product_type === 'Mattress' || item.product_type === 'Topper') {
        payload = {
          updates: {}
        };

        var mattressAmount = item.quantity + amount;
        var sheets = this.cartData.items.filter(function(cartItem) {
          var isFreeWithMattress = (
            cartItem.url.indexOf('free-w-mattress') > -1 ||
            cartItem.url.indexOf('free-w-topper') > -1
          );
          var belongsToMattress = cartItem.properties &&
            cartItem.properties.mattress &&
            cartItem.properties.mattress.indexOf(item.id) > -1;

          return isFreeWithMattress && belongsToMattress;
        });
        var i = sheets.length - 1;
        var remainingSheets = mattressAmount;

        while (i > -1) {
          var sheet = sheets[i];

          if (sheet.quantity > remainingSheets) {
            payload.updates[sheet.id] = remainingSheets;

            remainingSheets -= remainingSheets;
          } else {
            remainingSheets -= sheet.quantity;
          }

          i--;
        }

        payload.updates[item.id] = mattressAmount;
        this.queueCall({
          method: 'POST',
          url: '/cart/update.js',
          data: payload
        });
      } else {
        this.queueCall({
          method: 'POST',
          url: '/cart/change.js',
          data: payload
        });
      }
    }

    this.fetchCart();
  },

  removeBundle: function (event) {
    if (!event) {
      return;
    }

    event.preventDefault();

    var $target = $(event.currentTarget);
    var index = $target.closest('.drawer-item-listing').data('product-id');
    var item = this.cartData.items.filter(function(item) {
      return item.id === index
    })[0];

    var bundleId = (item.properties && item.properties.bundleId) ?  item.properties.bundleId : null;

    var payload = {};
    payload[index] = 0;

    this.cartData.items.forEach(function(bundleItem) {
      if (bundleItem.properties.bundleId === bundleId) {
        payload[bundleItem.id] = 0;
      }
    });

    this.queueCall({
      method: 'POST',
      url: '/cart/update.js',
      data: { updates: payload }
    });

    this.fetchCart();
  }
});
